import { NavLink } from 'react-router';
import { LayoutDashboard, Users, BarChart3, CreditCard, LogOut, Sparkles, Bot, Settings, Wand2, Mail, BookOpen, Newspaper } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { path: '/', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/analytics', label: 'Analytics', icon: BarChart3 },
  { path: '/twins', label: 'Twins', icon: Bot },
  { path: '/users', label: 'Users', icon: Users },
  { path: '/demo-users', label: 'Demo Users', icon: Wand2 },
  { path: '/billing', label: 'Billing', icon: CreditCard },
  { path: '/email', label: 'Email', icon: Mail },
  { path: '/best-practices', label: 'Best Practices', icon: BookOpen },
  { path: '/blog-press', label: 'Blog/Press', icon: Newspaper },
];

const bottomNavItems = [
  { path: '/settings', label: 'Settings', icon: Settings },
];

export function Sidebar() {
  const { logout } = useAuth();

  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-[#0f0f1a] border-r border-[#252535] flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-[#252535]">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 gradient-blue rounded-xl flex items-center justify-center shadow-md glow-blue">
            <Sparkles className="w-4 h-4 text-white" />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-[15px] font-semibold text-[#f1f5f9]">OBAET</span>
            <span className="text-[11px] text-[#64748b] font-medium tracking-widest uppercase">Admin</span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        <p className="text-[10px] font-semibold text-[#64748b] tracking-widest uppercase px-4 mb-3">
          Main Menu
        </p>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 relative ${
                isActive
                  ? 'bg-[#3b82f6]/10 text-[#3b82f6] nav-item-active'
                  : 'text-[#94a3b8] hover:text-[#f1f5f9] hover:bg-[#1c1c2a]'
              }`
            }
          >
            <item.icon className="w-4 h-4 shrink-0" />
            <span className="flex-1">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Bottom nav + Logout */}
      <div className="p-4 border-t border-[#252535] space-y-1">
        {bottomNavItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 relative ${
                isActive
                  ? 'bg-[#3b82f6]/10 text-[#3b82f6] nav-item-active'
                  : 'text-[#94a3b8] hover:text-[#f1f5f9] hover:bg-[#1c1c2a]'
              }`
            }
          >
            <item.icon className="w-4 h-4 shrink-0" />
            <span className="flex-1">{item.label}</span>
          </NavLink>
        ))}
        <button
          onClick={logout}
          className="flex items-center gap-3 px-4 py-2.5 w-full rounded-xl text-sm font-medium text-[#64748b] hover:text-[#ef4444] hover:bg-[#ef4444]/8 transition-all duration-200"
        >
          <LogOut className="w-4 h-4 shrink-0" />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
